/**
 * 人员管理 web api
 * @author Risin.Xu
 * @create 2021-01-18 14:24:59
 */
import request from "@/utils/request";
import service from "@/utils/service"


export function sexList() {
  return [
    {id: 1, label: "男"},
    {id: 2, label: "女"}
  ]
}

/**
 * 查询人员管理列表
 */
export function list(param) {
  return request({
    url: service.tcode + "/base/psndoc/list",
    method: "post",
    data: param
  });
}

/**
 * 保存人员管理数据
 */
export function save(data) {
  return request({
    url: service.tcode + "/base/psndoc/save",
    method: "post",
    data: data
  });
}

/**
 * 根据PK查询一个人员管理
 */
export function get(pk) {
  return request({
    url: service.tcode + "/base/psndoc/get/" + pk,
    method: "get"
  });
}

/**
 * 启用
 */
export function unseal(pk) {
  return request({
    url: service.tcode + "/base/psndoc/unseal/" + pk,
    method: "get"
  });
}

/**
 * 停用
 */
export function seal(pk) {
  return request({
    url: service.tcode + "/base/psndoc/seal/" + pk,
    method: "get"
  });
}

/**
 * 修改人员信息
 */
export function updatePsndoc(data) {
  return request({
    url: service.tcode + "/base/psndoc/updatePsndoc",
    method: "post",
    data: data
  });
}

/**
 * 根据PK删除
 */
/*export function delData(pk) {
  return request({
    url: service.tcode + "/base/psndoc/delete/" + pk,
    method: "get"
  });
}*/

/**
 * 批量删除
 */
/*export function deleteBatch(pks) {
  return request({
    url: service.tcode + "/base/psndoc/deleteBatch",
    method: "post",
    data: pks
  });
}*/


/**
 * 银行账号保存
 * @param pk 主键
 */
/*export function savePsnBank(param) {
  return request({
    url: service.tcode + "/base/psndoc/savePsnBank",
    method: "post",
    data: param
  })
}*/

/**
 * 根据pk_bank获取银行信息
 * @author Huixin.Meng
 * @date 2021/04/09 14:31:28
 */
/*export function getBankInfo(pk) {
  return request({
    url: service.tcode + "/base/bank/get/" + pk,
    method: "get"
  })
}*/


/*export function getByCode(code) {
  return request({
    url: service.tcode + "/base/psndoc/getByCode/" + code,
    method: "get"
  })
}*/




// WEBPACK FOOTER //
// ./src/api/base/psndoc.js